"use client";

import { useState } from "react";

import { PricingOverview } from "@/components/pricing/overview";
import { UsageTable } from "@/components/pricing/usage-table";
import { type BillingInterval } from "@/lib/pricing-data";
import PageContent from "@/components/page-content";

const PricingContent = () => {
  const [billingInterval, setBillingInterval] =
    useState<BillingInterval>("yearly");

  return (
    <PageContent className="pb-12 pt-20">
      <div className="mx-auto max-w-5xl text-center">
        <h2 className="mb-3 text-4xl font-bold text-pretty lg:text-6xl">
          Pricing
        </h2>
        <p className="text-muted-foreground lg:text-xl">
          Simple, transparent pricing for every stage of growth.
        </p>
      </div>
      <PricingOverview
        className="pt-12"
        billingInterval={billingInterval}
        onBillingIntervalChange={setBillingInterval}
      />
      <UsageTable />
    </PageContent>
  );
};

export { PricingContent };
